import {SideNavigation, SideNavigationProps} from '@amzn/awsui-components-react';
import React from 'react';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {
    getAcPageUrl, getApprovalPageUrl,
    getHomeUrl,
    getIapPageUrl,
    getIogPageUrl,
    getMappingsPageUrl,
    getStartWorkflowPageUrl,
    getWorkflowHistoryPageUrl,
    getDynamicExecutionPageUrl,
    getRuleGroupPageUrl,
    getExclusionGroupPageUrl,
} from '../../backend/internalUrls';
import {getPermissions} from "../../backend/backend";

const searchSection: SideNavigationProps.Section = {
    type: 'section',
    text: 'Search',
    items: [
        {type: 'link', text: 'AC', href: getAcPageUrl()} as SideNavigationProps.Link,
        {type: 'link', text: 'IOG', href: getIogPageUrl()} as SideNavigationProps.Link,
        {type: 'link', text: 'IAP', href: getIapPageUrl()} as SideNavigationProps.Link,
    ],
}
const workflowsSection: SideNavigationProps.Section = {
    type: 'section',
    text: 'Workflows',
    items: [
        {type: 'link', text: 'Start', href: getStartWorkflowPageUrl()} as SideNavigationProps.Link,
        {type: 'link', text: 'History', href: getWorkflowHistoryPageUrl()} as SideNavigationProps.Link,
    ],
}
const dncSection: SideNavigationProps.Section = {
    type: 'section',
    text: 'Dynamic Executions',
    items: [
        {type: 'link', text: 'History', href: getDynamicExecutionPageUrl()} as SideNavigationProps.Link,
        {type: 'link', text: 'Rule Groups', href: getRuleGroupPageUrl()  } as SideNavigationProps.Link,
        {type: 'link', text: 'Exclusion Groups', href: getExclusionGroupPageUrl()  } as SideNavigationProps.Link,
    ],
}
const adminSection: SideNavigationProps.Section = {
    type: 'section',
    text: 'Admin',
    items: [
        {type: 'link', text: 'Manage Mappings', href: getMappingsPageUrl()} as SideNavigationProps.Link,
        {type: 'link', text: 'Approval', href: getApprovalPageUrl()} as SideNavigationProps.Link,
    ],
}

function getPlainPathName(pathname: string) {
    switch (pathname) {
        case getStartWorkflowPageUrl():
        case getWorkflowHistoryPageUrl():
        case getAcPageUrl():
        case getIogPageUrl():
        case getIapPageUrl():
        case getDynamicExecutionPageUrl():
        case getRuleGroupPageUrl():
            return pathname
        default:
            return pathname.substring(0, pathname.lastIndexOf('/'))
    }
}

export function isExternalLink(url: string): boolean {
    return !!url && (url.startsWith('http://') || url.startsWith('https://'));
}

async function executeGetPermissions() {
    try {
        const response = (await getPermissions()).data
        return response;
    } catch (error: any) {
        console.error(error)
    } finally {

    }
}

type MenuStateType = { items: SideNavigationProps.Item[] }

class Menu extends React.Component<RouteComponentProps, MenuStateType> {

    constructor(props: Readonly<RouteComponentProps>) {
        super(props);
        const items: SideNavigationProps.Item[] = []

        this.state = {
            items,
        }
        this.onFollowHandler = this.onFollowHandler.bind(this)
    }

    componentDidMount() {
        executeGetPermissions().then(data => {
            const items = [
                {
                    item: searchSection,
                    isVisible: true
                },
                {
                    item: workflowsSection,
                    isVisible: true
                },
                {
                    item: dncSection,
                    isVisible: true
                },
                {
                    item: adminSection,
                    isVisible: data && data.permissions.includes("APABrewery")
                },
            ].filter(itemProps => itemProps.isVisible).map(itemProps => itemProps.item)
            this.setState({items})
        })
    }

    onFollowHandler(event: CustomEvent<SideNavigationProps.FollowDetail>): void {
        event.preventDefault();

        if (isExternalLink(event.detail.href)) {
            window.open(event.detail.href);
        } else this.props.history.push(event.detail.href)
    }

    render(): JSX.Element {
        return (
            <SideNavigation
                id='menu'
                header={{href: getHomeUrl(), text: 'Availability Pool Analyzer'}}
                items={this.state.items}
                activeHref={getPlainPathName(this.props.location.pathname)}
                onFollow={this.onFollowHandler}
            />
        )
    }
}

export default withRouter(Menu)
